"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reserveKeys = void 0;
var reserveKeys = ['select', 'create', 'insert', 'from', 'where', 'order', 'limit', 'by', 'sounds', 'like', 'is', 'in', 'between', 'regexp', 'isnull', 'lateral', 'left', 'right', 'inner', 'outer', 'join'];
exports.reserveKeys = reserveKeys;